import React from 'react';
import PropTypes from 'prop-types';
import { Context } from '../../Context';
import { withStyles } from '@material-ui/core/styles';
import { Button, Tooltip, Grid, CardActions, Card, IconButton, CardHeader, Avatar, FormControl, TextField, FormControlLabel, FormGroup, Checkbox, CardMedia, CardContent, Typography, Divider, Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText } from '@material-ui/core/';
import InfluencerDetailsStyles from '../../Styles/InfluencerDetailsStyles';
import { Close } from '@material-ui/icons';
import { Mixpanel } from '../../Config/mixpanel';

class InfluencerDetails extends React.Component {
	constructor() {
		super();
		this.state = {
			repostDialogOpen: false,
			storyDialogOpen: false,
			rejectDialogOpen: false,
			rejectFeedback: [],
			otherRejectReason: '',
			otherRejectReasonOpen: false,
			firstTimeShortListHelp: true,
			shortlistDialogOpen: false
		};
	}

	toggleRejectDialog = event => {
		this.setState({
			rejectDialogOpen: !this.state.rejectDialogOpen
		});
	}

	handleRejectConfirm = event => {
		const newRejectFeedback = this.state.rejectFeedback.concat(this.state.otherRejectReason).join('; ');

		Mixpanel.track('MagicLink campaign rejected influencer', {
			campaignName: this.props.campaignName,
			magicLink: this.props.magicLink,
			influencerId: this.props.influencer.influencerId,
			feedback: newRejectFeedback
		});

		this.props.updateInfluencers([
			{
				influencerId: this.props.influencer.influencerId,
				nextStage: 'RejectedByBrand',
				rejectionExplanation: newRejectFeedback
			}
		]);

		this.toggleRejectDialog();
	}

	handleOtherRejectReasonText = event => {
		this.setState({
			otherRejectReason: event.target.value
		});
	};

	handleDeclineFeedback = (event, feedback) => {
		let newRejectFeedback = [];

		if (event.target.checked) {
			newRejectFeedback = this.state.rejectFeedback.concat(feedback);
		} else {
			newRejectFeedback = this.state.rejectFeedback.filter((f) => f !== feedback);
		}
		this.setState({
			rejectFeedback: newRejectFeedback
		});

		if (feedback === 'Other (please tell us more?)') {
			this.setState({ otherRejectReasonOpen: true });
		}
	}

	toggleShortlistDialog = event => {
		if (this.state.firstTimeShortListHelp) {
			this.setState({
				shortlistDialogOpen: true,
				firstTimeShortListHelp: false
			});
		} else {
			this.confirmShortlist();
		}
	}

	cancelShortlistDialog = event => {
		this.setState({ shortlistDialogOpen: false })
	}

	confirmShortlist = event => {
		Mixpanel.track('MagicLink campaign shortlisted influencer', {
			campaignName: this.props.campaignName,
			magicLink: this.props.magicLink,
			influencerId: this.props.influencer.influencerId
		});

		this.props.updateInfluencers([
			{
				influencerId: this.props.influencer.influencerId,
				nextStage: 'AcceptedByBrand'
			}
		]);

		this.setState({
			shortlistDialogOpen: false,
			firstTimeShortListHelp: false
		});
	}

	render() {
		const { classes } = this.props;
		const { influencer } = this.props;

		let openForText = null;
		let location = 'Other';
		let influencerEmail = null;

		if (influencer && (influencer.paidCollaborations || influencer.brandAffiliate || influencer.brandProductExchange)) {
			openForText = (
				<Typography variant="body1" >
					Open for:
					{influencer.paidCollaborations && (<React.Fragment><br /> - Paid collaborations</React.Fragment>)}
					{influencer.brandProductExchange && (<React.Fragment><br /> - Gifted reviews</React.Fragment>)}
					{influencer.brandAffiliate && (<React.Fragment><br /> - Affiliate or revenue share</React.Fragment>)}
				</Typography>);
		} else {
			openForText = (
				<Typography variant="body1" >
					<br /><br /><br /><br />
				</Typography >);
		}

		if (influencer.country && influencer.country !== 'OTHER') {
			location = influencer.country;
		} else if (influencer.igTag && influencer.igTag.county && influencer.igTag.county !== 'OTHER') {
			location = influencer.igTag.county;
		}

		if (influencer.status === 'AcceptedByBrand') {
			if (influencer.email) {
				influencerEmail = influencer.email;
			} else if (influencer.igTag.email) {
				influencerEmail = influencer.igTag.email;
			}
		}

		return (
			<div>
				<Card className={classes.card}>
					<CardHeader
						avatar={
							<Avatar alt="Instagram Logo" variant="rounded" className={classes.logo} src="https://storage.googleapis.com/vimma/ig_logo_40px.png" />
						}
						action={influencer.status !== 'RejectedByBrand' && (
							<Tooltip title='Reject this content creator. You can still find the creator in the Not Selected section.'>
								<IconButton aria-label="Delete" className={classes.icon} onClick={this.toggleRejectDialog}>
									<Close fontSize="default" />
								</IconButton>
							</Tooltip>)
						}
						title={<a href={`https://www.instagram.com/${influencer.influencerId}`} target='_blank' rel="noopener noreferrer" style={{ color: 'inherit' }}>
							{influencer.influencerId}
						</a>}
						subheader={influencer.edge_followed_by && influencer.edge_followed_by.count && influencer.edge_followed_by.count > 999 ?
							`${(influencer.edge_followed_by.count / 1000).toFixed(1)}K followers` :
							'<1K followers'
						}
					/>
					<a href={`https://www.instagram.com/${influencer.influencerId}`} target='_blank' rel="noopener noreferrer">
						<CardMedia
							className={classes.media}
							image={influencer.profile_pic_url_hd}
							title="Instagram Post"
						/>
					</a>
					<CardContent>
						<Typography variant="body1" >
							Engagement rate: <b>{influencer.postEngagementPercent ? `${influencer.postEngagementPercent.toFixed(2)}%` : 'N/A'}</b>
						</Typography>
						<Typography variant="body1" >
							Location: <b>{location}</b>
						</Typography>
						{influencer.status === 'AcceptedByBrand' && (
							<Typography variant="body1" >
								Email: {influencerEmail ? <a href={`mailto:${influencerEmail}`} style={{ color: 'inherit' }}>{influencerEmail}</a> : 'Unknown'}
							</Typography>
						)}
						{openForText && (
							<React.Fragment >
								{openForText}
							</React.Fragment>
						)}
					</CardContent>
					{influencer.status !== 'AcceptedByBrand' && (
						<React.Fragment>
							<Divider />
							<CardActions>
								<Grid
									container
									spacing={0}
									direction='row'
									justify='flex-end'>
									<Grid item>
										<Tooltip title='By shortlisting a creator you can see and export their contact details'>
											<Button color='primary' onClick={this.confirmShortlist}>
												Shortlist
											</Button>
										</Tooltip>
									</Grid>
								</Grid>
							</CardActions>
						</React.Fragment>)}
				</Card>

				<Dialog
					maxWidth="sm"
					aria-labelledby="shortlist-dialog"
					open={this.state.shortlistDialogOpen}
				>
					<DialogTitle id="story-confirmation-dialog-title">
						Shortlisting a creator
					</DialogTitle>
					<DialogContent>
						<DialogContentText>
							This will move the creator to the shortlisted list below.
						</DialogContentText>
						<DialogContentText>
							Once you finished shortlisting, you can review, modify and export creators' contacts.
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button onClick={this.cancelShortlistDialog}>
							Cancel
          				</Button>
						<Button onClick={this.confirmShortlist} color="primary">
							Ok, don't show this again
          				</Button>
					</DialogActions>
				</Dialog>

				<Dialog
					maxWidth="sm"
					aria-labelledby="reject-influencer-dialog-title"
					open={this.state.rejectDialogOpen}
				>
					<DialogTitle id="reject-influencer-dialog-title">Are you sure you want to remove this creator from your campaign?</DialogTitle>
					<DialogContent>
						<DialogContentText>
							Before you confirm, please give us feedback so we can serve your brand better in the future:
            			</DialogContentText>
					</DialogContent>
					<DialogContent>
						<FormControl>
							<FormGroup >
								<FormControlLabel
									control={
										<Checkbox
											onChange={(event) => this.handleDeclineFeedback(event, 'Creator does not fit the desired demographics')}
											color="primary"
										/>
									}
									label='Creator does not fit the desired demographics'
								/>
								<FormControlLabel
									control={
										<Checkbox
											onChange={(event) => this.handleDeclineFeedback(event, 'Creator’s content is not up to standards')}
											color="primary"
										/>
									}
									label="Creator’s content is not up to standards"
								/>
								<FormControlLabel
									control={
										<Checkbox
											onChange={(event) => this.handleDeclineFeedback(event, 'Creator does not fit the brand')}
											color="primary"
										/>
									}
									label="Creator does not fit the brand"
								/>
								<FormControlLabel
									control={
										<Checkbox
											onChange={(event) => this.handleDeclineFeedback(event, 'Other (please tell us more?)')}
											color="primary"
										/>
									}
									label="Other (please tell us more?)"
								/>
							</FormGroup>
						</FormControl>
					</DialogContent>
					{this.state.otherRejectReasonOpen && (<DialogContent>
						<TextField
							label="Other reason"
							value={this.state.otherRejectReason}
							onChange={this.handleOtherRejectReasonText}
							fullWidth
							margin="normal"
							variant="outlined"
							multiline={true}
							rows={2}
							required={true}
							helperText='Please enter your reason for rejecting this creator'
						/>
					</DialogContent>)}
					<DialogActions>
						<Button onClick={this.toggleRejectDialog}>
							Cancel
          				</Button>
						<Button onClick={this.handleRejectConfirm} color="primary">
							Accept
          				</Button>
					</DialogActions>
				</Dialog>
			</div >
		);
	}
}

InfluencerDetails.propTypes = {
	classes: PropTypes.object.isRequired
};

InfluencerDetails.contextType = Context;

export default withStyles(InfluencerDetailsStyles)(InfluencerDetails);
